import React from 'react';
import { Typography, TextField, Button } from '@mui/material';

const AiInstructions = ({ aiInstructions, setAiInstructions, updateAiInstructions }) => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        AI Assistant Instructions
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={30}
        value={aiInstructions}
        onChange={(e) => setAiInstructions(e.target.value)}
        variant="outlined"
        margin="normal"
      />
      <Button variant="contained" color="primary" onClick={updateAiInstructions}>
        Update Instructions
      </Button>
    </>
  );
};

export default AiInstructions;
